import {
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {UserNamespace} from '@namespaces/user.namespace';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';
import {TechnicalDeviceDocumentsPagesService} from '../../services/documents/technical-device-documents-pages.service';

@Component({
    selector: 'app-documents',
    templateUrl: 'documents.component.html',
    styleUrls: ['documents.component.scss'],
})

export class DocumentsComponent extends ListItemsComponent<TechnicalDeviceDocumentsPagesService> implements OnInit, OnDestroy {
    public permissions = UserNamespace.Permission;

    constructor(
        service: TechnicalDeviceDocumentsPagesService
    ) {
        super(service);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngOnDestroy() {

    }
}
